import { BOX_PRINTINGS } from './products.enums'

export class PrintingSettings {
  color
  file

  constructor () {
    this.color = BOX_PRINTINGS.NONE
    this.file = null
  }
}
